"use client";
import { GO_REST_URL } from "@/lib/constants";
import axios from "axios";

interface FileResponse {
  file: Blob;
  mimeType: string
}
export const uploadFile = async (file: File): Promise<FileResponse> => {
  try {
    const formData = new FormData();
    formData.append("pdf_file", file);

    const response = await axios.post(
      `${GO_REST_URL}/v1/compress-pdf`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "arraybuffer",
        onUploadProgress: (progressEvent) => {
          console.log(`Uploaded: ${progressEvent.loaded} bytes`);
        },
      }
    );
    console.log("File uploaded successfully:");
    const contentType = response.headers['content-type'];
    const fileBlob = new Blob([response.data], { type: contentType });
    return { file: fileBlob, mimeType:contentType };
  } catch (error) {
    console.error("Error uploading PDF", error);
    throw error;
  }
};

export const uploadPDF = async (
  formData: FormData,
  path: string
): Promise<FileResponse> => {
  try {

    const response = await axios.post(
      path,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "arraybuffer",
        onUploadProgress: (progressEvent) => {
          console.log(`Uploaded: ${progressEvent.loaded} bytes`);
        },
      }
    );

    console.log("File uploaded successfully:");

    const contentType = response.headers['content-type'];
    const fileBlob = new Blob([response.data], { type: contentType });
    return { file: fileBlob, mimeType:contentType };
  } catch (error) {
    console.error("Error uploading PDF", error);
    throw error;
  }
};
